import React, { useState, useEffect } from 'react';
import axios from "axios";
import { Table, Form } from 'react-bootstrap';
import chatdeposit from '../../assets/img/chatdeposit.png'
import deactiveuser from '../../assets/img/deactiveuser.png'
import useractive from '../../assets/img/useractive.png'
import chatwithdraw from '../../assets/img/chatwithdraw.png'
import Swal from "sweetalert2";
import edit from '../../assets/img/edit.png'
import {
    Row, Col, Container, Card, Modal,
    OverlayTrigger, Tooltip, Button, Badge
} from 'react-bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Pagination from 'react-bootstrap/Pagination';

import { useNavigate } from 'react-router-dom';
const ProfilePage = () => {
    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);
    const userid = localStorage.getItem("userid");
    const [totalUsers, setTotalUsers] = useState(0);
    const [totalActiveUsers, setTotalActiveUsers] = useState(0);
    const [totalInactiveUsers, setTotalInactiveUsers] = useState(0);
    const [activeTab, setActiveTab] = useState("total");
    const [searchQuery, setSearchQuery] = useState("");
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [user, setUser] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [newUserName, setNewUserName] = useState(user.userName || "");
    const [error, setError] = useState(null);
    const [shows, setShows] = useState(false);
    const [username, setUsername] = useState("");
    const [mobile, setMobile] = useState("");
    const [password, setPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const handleShows = () => setShows(true);
    const handleClosed = () => setShows(false);
    const handleSubmit = async () => {
        const userData = {
            userName: username,
            // mobileNumber: mobile,
            password: password,
        };
        console.log("User Data ➤", userData);

        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL}admin/add-user`, userData);
            if (res.data.success === 1) {
                Swal.fire({
                    icon: "success",
                    title: "User Added",
                    text: "User added successfully!",
                    timer: 2000,
                    showConfirmButton: false,
                });
                handleClosed();
                window.location.reload();
            } else {
                Swal.fire({
                    icon: "warning",
                    title: "Failed to Add",
                    text: res.data.message || "User could not be added.",
                });
            }
        } catch (error) {
            console.error("Error adding user:", error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Something went wrong. Please try again.",
            });
        }
    };


    const handleEdit = (user) => {
        setUser(user);
        setNewUserName(user.userName);
        setNewPassword("");
        setIsModalOpen(true);
    };

    const handleClose = () => {
        setIsModalOpen(false);
    };

    const navigate = useNavigate()
    useEffect(() => {
        loadUsers();
    }, []);

    const loadUsers = async () => {
        let url = `${process.env.REACT_APP_API_URL}usersListpl`;
        setLoading(true);

        try {
            const response = await axios.get(url);
            let usersData = response.data || [];

            // First, sort by status (active first), then by unseen (high to low)
            usersData.sort((a, b) => {
                // If statuses are different, sort active users first
                if (a.status !== b.status) return b.status - a.status;

                // If statuses are the same, sort by unseen count
                return b.unseen - a.unseen;
            });

            setUsers(usersData);
            setTotalUsers(usersData.length);
            setTotalActiveUsers(usersData.filter(user => user.status === 1).length);
            setTotalInactiveUsers(usersData.filter(user => user.status === 0).length);
        } catch (error) {
            console.error("Error fetching user data:", error);
        } finally {
            setLoading(false);
        }
    };



    const handleAction = async (action, userId, statusUpdate) => {
        console.log(`Action: ${action}, User ID: ${userId}, Current Status: ${statusUpdate}`);

        if (action === "changeStatus") {
            setLoading(true);
            let url = `${process.env.REACT_APP_API_URL}admin/status-change`;

            const newStatus = statusUpdate === 1 ? 0 : 1;

            try {
                await axios.post(url, { userId, status: newStatus });
                await loadUsers();
            } catch (error) {
                console.error("Error updating user status:", error);
            } finally {
                setLoading(false);
            }
        } else if (action === "chatWithdraw") {
            navigate("/Withdrawalchat");
            localStorage.setItem("receiverId", userId);
        } else if (action === "chatDeposit") {
            navigate("/DepositchatSocket");
            localStorage.setItem("receiverId", userId);
        }
    };

    const filteredUsers = users.filter((user) => {
        if (activeTab === "active" && user.status !== 1) {
            return false;
        }
        if (activeTab === "inactive" && user.status !== 0) {
            return false;
        }
        if (
            searchQuery &&
            !user.userName.toLowerCase().includes(searchQuery.toLowerCase())
        ) {
            return false;
        }

        return true;
    });

    // Paginate the filtered transactions
    const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentUsers = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };


    // const updateUserName = async () => {
    //     try {
    //         const response = await axios.post("https://api.Cash365days.in/updateUserName", {
    //             userId: user._id,
    //             userName: newUserName,
    //         });

    //         if (response.data.success === 1) {
    //             setUsers((prevUsers) =>
    //                 prevUsers.map((u) =>
    //                     u._id === user._id ? { ...u, userName: newUserName } : u
    //                 )
    //             );
    //             setIsModalOpen(false);
    //             await loadUsers();
    //         } else {
    //             setError("Failed to update username");
    //         }
    //     } catch (err) {
    //         setError("Failed to update username");
    //     }
    // };

    const updateUserName = async () => {
        try {

            const payload = {
                userId: user._id,
                userName: newUserName,
            };
            if (newPassword.trim() !== "") {
                payload.password = newPassword;
            }
            // const response = await axios.post(`${process.env.REACT_APP_API_URL}updateUserName`, {
            //     userId: user._id,
            //     userName: newUserName,
            // });
            const response = await axios.post(`${process.env.REACT_APP_API_URL}updateUserName`,
                payload
            );

            console.log("API Response:", response.data);

            if (response.status === 200) {
                console.log("User updated successfully, calling loadUsers()");

                await loadUsers(); // Ensure this function is executed

                // Update state manually instead of full reload
                setUser(prevUser => ({
                    ...prevUser,
                    userName: newUserName
                }));

                setIsModalOpen(false);
            } else {
                setError("Failed to update username");
            }
        } catch (err) {
            console.error("❌ Error updating username:", err);
            setError("Failed to update username");
        }
    };


    return (
        <div className="profile-container">
            <Row className="g-4">

                <Col md={6} lg={4}>
                    <Card
                        onClick={() => setActiveTab("total")}
                        className="shadow-sm text-center overflow-hidden"
                        style={{ cursor: "pointer" }}
                    >
                        <Card.Body className="d-flex align-items-center position-relative p-0">
                            <div className="icon-container">
                                <i className="bi bi-people fs-1"></i>
                            </div>
                            <div className="content_details">
                                <Card.Title className="titlefordiv">Total Users</Card.Title>
                                <Card.Text className="cardtext">{totalUsers}</Card.Text>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={6} lg={4}>
                    <Card onClick={() => setActiveTab("active")}
                        className="shadow-sm text-center overflow-hidden"
                        style={{ cursor: "pointer" }}
                    >
                        <Card.Body className="d-flex align-items-center position-relative p-0">
                            <div className="icon-container">
                                <i className="bi bi-cash-stack fs-1"></i>
                            </div>
                            <div className="content_details">
                                <Card.Title className="titlefordiv">Active Users</Card.Title>
                                <Card.Text className="cardtext">{totalActiveUsers}</Card.Text>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                {/* Withdrawal Box */}
                <Col md={6} lg={4}>
                    <Card onClick={() => setActiveTab("inactive")}
                        className="shadow-sm text-center overflow-hidden"
                        style={{ cursor: "pointer" }}
                    >
                        <Card.Body className="d-flex align-items-center position-relative p-0">
                            <div className="icon-container">
                                <i className="bi bi-wallet2 fs-1"></i>
                            </div>
                            <div className="content_details">
                                <Card.Title className="titlefordiv">Inactive Users</Card.Title>
                                <Card.Text className="cardtext">{totalInactiveUsers}</Card.Text>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <div className='table-responsive tablemargin'>
                <div className="d-flex align-items-center justify-content-between w-100">
                    <p className='text-start mt-2 requesthistory w-100'>User List</p>
                    <div className="d-flex align-items-center">
                        <div className="input-group mt-3 me-3"
                            style={{ width: "235px" }}
                        >
                            <span className="input-group-text">
                                <i className="bi bi-search"></i>
                            </span>
                            <input
                                type="text"
                                placeholder="Search by username"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="form-control"
                            />
                        </div>
                    </div>
                    <button className='btn btn-primary add-btn' onClick={handleShows}>
                        Add User
                    </button>
                </div>
                <Table striped bordered hover className='tablehistory position-relative'>
                    <thead>
                        <tr>
                            <th>S No</th>
                            <th>User Name</th>
                            <th>password</th>
                            <th>P/L</th>
                            {/* <th>Seen</th> */}
                            <th>Unseen</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody className='tbodyhistroy'>
                        {currentUsers.length > 0 ? (
                            currentUsers.map((user, index) => (
                                <tr className="text-center bg-transparent" key={user._id}>
                                    <td>{index + indexOfFirstItem + 1}</td>
                                    {/* {users.length > 0 ? (
                            users.map((user, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td> */}
                                    <td>{user.userName}</td>
                                    <td>{user.password}</td>
                                    {/* <td style={{ color: user.balance < 0 ? "red" : "green" }}>
                                        {user.balance || 0}
                                    </td> */}
                                    <td style={{ color: user.profitOrLoss < 0 ? "red" : "green" }}>{user.profitOrLoss}</td>

                                    {/* <td>{user.seen}</td> */}
                                    {/* <td
                                        style={{
                                            backgroundColor: user.unseen > 0 ? "red !important" : "green !important",
                                            color: "white",
                                            padding: "3px 6px",
                                            borderRadius: "12px",
                                            fontSize: "12px",
                                            display: "inline-block",
                                        }}
                                    >
                                        {user.unseen}
                                    </td> */}

                                    <td >
                                        <span className={user.unseen > 0 ? "highlight" : ""}>
                                            {user.unseen}

                                        </span>
                                    </td>

                                    <td style={{ color: user.status === 1 ? "green" : "red" }}>{user.status === 1 ? "Active" : "Inactive"}</td>
                                    <td className="usereduttablie">
                                        {/* Chat Deposit Button */}
                                        <OverlayTrigger placement="top" overlay={<Tooltip>Chat Deposit</Tooltip>}>
                                            <Button className="buttonAction chatDeposit"
                                                variant="primary"
                                                size="sm"
                                                onClick={() => handleAction('chatDeposit', user._id)}
                                            >
                                                <div className="iconnew">
                                                    <img src={chatdeposit} alt="chatdeposit" />
                                                    {user.depositunseen > 0 && (
                                                        <Badge bg="danger" className="ms-1">{user.depositunseen}</Badge>
                                                    )}
                                                </div>
                                            </Button>
                                        </OverlayTrigger>{' '}

                                        {/* Chat Withdraw Button */}
                                        <OverlayTrigger placement="top" overlay={<Tooltip>Chat Withdraw</Tooltip>}>
                                            <Button className="buttonAction chatWithdraw"
                                                variant="warning"
                                                size="sm"
                                                onClick={() => handleAction('chatWithdraw', user._id)}
                                            >
                                                <div className="iconnew">
                                                    <img src={chatwithdraw} alt="chatwithdraw" />
                                                    {user.withdrawunseen > 0 && (
                                                        <Badge bg="danger" className="ms-1">{user.withdrawunseen}</Badge>
                                                    )}
                                                </div>
                                            </Button>
                                        </OverlayTrigger>

                                        {/* Delete User Button */}
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip>{user.status === 1 ? "Deactivate User" : "Activate User"}</Tooltip>}
                                        >
                                            <Button
                                                className="buttonAction deleteUser"
                                                variant={user.status === 1 ? "success" : "danger"} // Red for deactivate, green for activate
                                                size="sm"
                                                onClick={() => handleAction("changeStatus", user._id, user.status)}
                                            >
                                                <div className="iconnew">
                                                    {user.status === 1 ? <img src={useractive} alt="deactiveuser" /> : <img src={deactiveuser} alt="useractive" />}

                                                </div>
                                            </Button>
                                        </OverlayTrigger>

                                        <OverlayTrigger placement="top" overlay={<Tooltip>Edit User</Tooltip>}>
                                            <Button
                                                className="buttonAction editUser"
                                                variant="info"
                                                size="sm"
                                                onClick={() => handleEdit(user)}
                                            >
                                                <div className="iconnew">
                                                    <img src={edit} alt="edit" /></div>
                                            </Button>
                                        </OverlayTrigger>

                                    </td>

                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="8" className='text-center nodataavl'>No data available</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
                <Modal show={isModalOpen} onHide={handleClose} centered className="modelcolornew">
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Username</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <label htmlFor="dd">New User Name</label>
                        <input
                            type="text"
                            value={newUserName}
                            onChange={(e) => setNewUserName(e.target.value)}
                            className="form-control"
                        />
                        <label>New Password</label>
                        <input
                            type="password"
                            placeholder="Enter new password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            className="form-control"
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="d-flex gap-2 justify-content-end align-items-center">
                            <div>
                                <Button variant="secondary" onClick={handleClose}>
                                    Close
                                </Button>
                            </div>
                            <div>

                                <Button variant="primary" onClick={updateUserName}>
                                    Update Username
                                </Button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>

                <Modal show={shows} onHide={handleClosed}>
                    <Modal.Header closeButton>
                        <Modal.Title>Add New User</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group className="mb-3" controlId="formUsername">
                                <Form.Label>Username</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter username"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                />
                            </Form.Group>

                            {/* <Form.Group className="mb-3" controlId="formMobile">
                                <Form.Label>Mobile Number</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter mobile number"
                                    value={mobile}
                                    onChange={(e) => setMobile(e.target.value)}
                                />
                            </Form.Group> */}

                            <Form.Group className="mb-3" controlId="formPassword">
                                <Form.Label>Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    placeholder="Enter password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="new_user_footer">
                        <Button variant="secondary" onClick={handleClosed}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={handleSubmit}>
                            Save User
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Row className="">
                    <Pagination className="justify-content-center">
                        <Pagination.First onClick={() => setCurrentPage(1)} />
                        <Pagination.Prev onClick={handlePrevPage} />

                        {/* Always show the first two pages */}
                        {[...Array(Math.min(2, totalPages))].map((_, index) => (
                            <Pagination.Item
                                key={index}
                                active={index + 1 === currentPage}
                                onClick={() => setCurrentPage(index + 1)}
                            >
                                {index + 1}
                            </Pagination.Item>
                        ))}

                        {/* Show ellipsis if current page is beyond the first two pages */}
                        {currentPage > 3 && <Pagination.Ellipsis disabled />}

                        {/* Show current page and its neighbors */}
                        {currentPage > 2 && currentPage < totalPages - 1 && (
                            <>
                                <Pagination.Item
                                    active
                                    onClick={() => setCurrentPage(currentPage)}
                                >
                                    {currentPage}
                                </Pagination.Item>
                            </>
                        )}

                        {/* Show ellipsis if current page is not near the end */}
                        {currentPage < totalPages - 2 && <Pagination.Ellipsis disabled />}

                        {/* Always show the last two pages */}
                        {[...Array(Math.min(2, totalPages))].map((_, index) => {
                            const pageNumber = totalPages - 1 - index;
                            return (
                                pageNumber > 1 && (
                                    <Pagination.Item
                                        key={pageNumber}
                                        active={pageNumber === currentPage}
                                        onClick={() => setCurrentPage(pageNumber)}
                                    >
                                        {pageNumber}
                                    </Pagination.Item>
                                )
                            );
                        }).reverse()}

                        <Pagination.Next onClick={handleNextPage} />
                        <Pagination.Last onClick={() => setCurrentPage(totalPages)} />
                    </Pagination>
                </Row>
            </div>
        </div>
    );
};

export default ProfilePage;